// ── Adapter Supabase do IHistoryRepository ────────────────────────
// Implementa a porta do módulo History usando o cliente Supabase. É a ÚNICA
// camada que conhece a tabela `history`. Eventos automáticos são gerados por
// triggers no banco; aqui só lê a timeline e grava notas manuais.

import { getSupabase, type TypedSupabaseClient } from '@infra/supabase/client';
import type { HistoryEntry } from '@/types/history';
import type {
  IHistoryRepository,
  AddHistoryNoteParams,
} from '@modules/history';

const requireSupabase = (): TypedSupabaseClient => {
  const s = getSupabase();
  if (!s) throw new Error('Supabase nao inicializado.');
  return s;
};

const SELECT_RICH = `
  *,
  author:profiles!history_created_by_fkey ( id, nome, initials, color, avatar_url )
`;

export class SupabaseHistoryRepository implements IHistoryRepository {
  listByLead = async (leadId: string): Promise<HistoryEntry[]> => {
    const supabase = requireSupabase();
    const { data, error } = await supabase
      .from('history')
      .select(SELECT_RICH)
      .eq('lead_id', leadId)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return (data || []) as unknown as HistoryEntry[];
  };

  addNote = async ({ workspaceId, leadId, cardId = null, text }: AddHistoryNoteParams): Promise<HistoryEntry> => {
    const supabase = requireSupabase();
    const { data: { user } } = await supabase.auth.getUser();
    const { data, error } = await supabase
      .from('history')
      .insert({
        workspace_id: workspaceId,
        lead_id:      leadId,
        card_id:      cardId,
        type:         'note_added',
        title:        text.trim().slice(0, 120),
        description:  text.trim(),
        created_by:   user?.id || null,
      })
      .select(SELECT_RICH)
      .single();
    if (error) throw error;
    return data as unknown as HistoryEntry;
  };
}
